import { BKJBadge } from '@bookjane2/bookjane-design-library';
import { ReactNode } from 'react';

export interface IShiftStatusBadge {
  status: keyof typeof ShiftStatusBadgeEnum;
  children: ReactNode;
  isBlockShift?: boolean;
}

enum ShiftStatusBadgeEnum {
  'accepted' = 'AcceptedPill',
  'assigned' = 'AssignedPill',
  'cancelled' = 'CancelledPill',
  'completed' = 'CompletedPill',
  'in_progress' = 'InProgressPill',
  'open' = 'OpenPill',
  'pending' = 'PendingPill',
  'rejected' = 'RejectedPill',
  'requested' = 'RequestedPill',
  'unfulfilled' = 'UnfulfilledPill',
  'swapped' = 'SwappedPill',
  'absent' = 'AbsentPill',
}
// design library change required

export const ShiftStatusBadge = ({
  status,
  children,
  isBlockShift,
  ...rest
}: IShiftStatusBadge): JSX.Element => {
  const variant =
    isBlockShift && (status === 'pending' || status === 'open')
      ? 'PendingBlockPill'
      : ShiftStatusBadgeEnum[status];
  return (
    <BKJBadge variant={variant} {...rest}>
      {children}
    </BKJBadge>
  );
};
